export const environment = {
  apiUrl: 'https://adandra.net/api',
  rootUrl: 'https://adandra.net',
  node: 'https://chat.adandra.net',
  storage: 'https://storage.adandra.net',
  production: true
};
